var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaudeDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D97757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C15F3D"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "url(#cd-bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    transform: "translate(80 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -38 L6 -10 L34 -4 L6 2 L0 30 L-6 2 L-34 -4 L-6 -10 Z",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 -26 L29 -18 L37 -15 L29 -12 L26 -4 L23 -12 L15 -15 L23 -18 Z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22 18 L-19 26 L-11 29 L-19 32 L-22 40 L-25 32 L-33 29 L-25 26 Z",
    opacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaudeDesign);
export default __webpack_public_path__ + "static/media/ClaudeDesign.1868df5525784ac8c5ca85ddee72e5ca.svg";
export { ForwardRef as ReactComponent };